import { AgentBadge } from './AgentBadge';

interface BriefNarrativeProps {
  narrative: string;
  generatedAt: string;
  generatedBy: 'agent' | 'fallback';
  modelLatencyMs: number;
  scannedCount: number;
}

export function BriefNarrative({
  narrative,
  generatedAt,
  generatedBy,
  modelLatencyMs,
  scannedCount,
}: BriefNarrativeProps) {
  const time = new Date(generatedAt).toLocaleTimeString('en-AU', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZoneName: 'short',
  });
  const meta =
    generatedBy === 'agent'
      ? `generated ${time} · ${scannedCount} incidents scanned · ${(modelLatencyMs / 1000).toFixed(1)}s`
      : `generated ${time} · deterministic fallback (model unavailable)`;

  return (
    <div className="bg-bg-secondary border border-border-default border-l-[3px] border-l-brand-lime rounded-xl px-[22px] py-[18px] mb-3.5">
      <div className="flex items-center gap-2.5 mb-2.5">
        <AgentBadge name={generatedBy === 'agent' ? 'Brief-Author' : 'Brief-Fallback'} size="md" />
        <span className="text-[10.5px] text-text-secondary font-mono">{meta}</span>
      </div>
      <p className="font-sans font-normal text-[14.5px] leading-[1.55] text-text-primary m-0 max-w-[78ch]">
        {narrative}
      </p>
    </div>
  );
}
